<template>
  <div class="student">
    <div
      v-if="article.backgroundImg"
      v-bind:style="'background-image:url('+article.backgroundImg.url+')'"
      class="hero"
    >
      <h1 class="main-head on-hero" v-if="!editing">{{article.name}}</h1>
      <input
        class="editer main-head on-hero"
        placeholder="שם השיעור"
        v-if="editing"
        v-model="article.name"
      />
      <div class="hero-grad"></div>
      <div v-if="mine && editing" class="editImage">
        <input @change="uploadImage($event)" class="mainImageupld" type="file" value="בחר תמונה" />בחר תמונה
      </div>
    </div>
    <div class="section-3 w-clearfix">
      <div v-if="$parent.user" class="side-tech-box popout hidden">
        <div v-on:click="openTeacher()" class="side-close-btn"></div>

        <h3 v-if="teacherInfo.topic || editing" class="side-tech-head sub">נושא השיעור</h3>
        <textarea v-if="editing" v-model="teacherInfo.topic" class="side-txt"></textarea>
        <p v-if="!editing" v-html="teacherInfo.topic" class="side-txt"></p>

        <h3 v-if="teacherInfo.purpose || editing" class="side-tech-head tar">מטרות השיעור</h3>
        <textarea v-if="editing" v-model="teacherInfo.purpose" class="side-txt"></textarea>
        <p v-if="!editing" v-html="teacherInfo.purpose" class="side-txt"></p>

        <h3 v-if="teacherInfo.strategy || editing" class="side-tech-head str">אסטרטגיות הוראה</h3>
        <textarea v-if="editing" v-model="teacherInfo.strategy" class="side-txt"></textarea>
        <p v-if="!editing" v-html="teacherInfo.strategy" class="side-txt"></p>

        <h3 v-if="teacherInfo.files.length || editing" class="side-tech-head dow">קבצים להורדה</h3>
        <div v-if="editing" style="position:relative;" class="add-new w-button">
          + הוספת קובץ חדש
          <input
            type="file"
            width="100%"
            height="100%"
            style="position: absolute;
            opacity: 0;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;"
          />
        </div>
        <h3 v-if="teacherInfo.test || editing" class="side-tech-head typ">שיטות הערכה</h3>
        <textarea
          placeholder="תוכן המאמר יהיה כאן"
          v-if="editing"
          v-model="teacherInfo.test"
          class="side-txt"
        ></textarea>
        <p v-if="!editing" v-html="teacherInfo.test" class="side-txt"></p>
        <div
          v-if="!teacherInfo.test && !teacherInfo.files.length && !teacherInfo.strategy && !teacherInfo.purpose && !teacherInfo.topic && !editing"
          class="side-txt"
        >
          <p class="empty-txt">טרם הועלה תוכן מיוחד למורה</p>
          <button v-if="mine" @click="editing = true" class="btn w-button">הוספת תוכן</button>
        </div>
      </div>
    </div>
    <div class="_1200">
      <a href="#" v-on:click="openTeacher()" v-if="$parent.user" class="teacher-action">מידע למורה</a>
      <div class="breadcrumbs-box space">
        <router-link to="/alternatives" class="breadcrumbs w-button">{{article.unit}}</router-link>
        <div class="yellow-slash-line"></div>
        <router-link
          :to="'/alternative/'+article.halufa"
          class="breadcrumbs w-button"
        >{{halufaname}}</router-link>
        <div class="yellow-slash-line"></div>
        <router-link
          :to="'/alternative/'+article.halufa"
          class="breadcrumbs w-button"
        >{{article.chapter}}</router-link>
      </div>
      <div class="_792 w-clearfix">
        <h3 class="side-head">המחבר</h3>
        <div class="_650 authorlink">
          <textarea
            class="author"
            type="text"
            placeholder="שם המחבר"
            v-model="article.author"
            v-if="editing"
          ></textarea>
          <p v-if="!editing" class="author">{{article.author}}</p>
          <label class="smallLabel" v-if="editing" for="source">לינק למקור</label>
          <input
            placeholder="לינק למקור"
            name="souce"
            type="text"
            width="100%"
            v-model="article.source"
            v-if="editing"
          />
          <a
            v-if="article.source && !editing"
            class="artilink"
            :href="article.source"
            target="_blank"
          >לינק למקור</a>
        </div>
      </div>
      <div class="_792 w-clearfix">
        <div style="width:100%;position:relative; display:block;">
          <div
            v-on:click="edit()"
            v-if="mine"
            style="float:right;"
            class="btn w-button floatleft"
          >{{editing?'שמירה':'ערוך מאמר'}}</div>
          <div
            v-on:click="deleteArticle()"
            v-if="mine"
            style="position:absolute;left:0;top:0"
            class="btn w-button floatleft"
          >
            מחיקה
            <span class="icon-font"></span>
          </div>
        </div>
        <textarea
          placeholder="Example Text"
          maxlength="5000"
          id="content"
          name="field"
          data-name="Field"
          v-model="article.content"
          v-if="editing"
          class="textedit w-input hide"
        ></textarea>
        <div class="_650">
          <div v-html="article.content" v-if="!editing" class="paragraph-rtf w-richtext">
            <h2>פתיח</h2>
            <p>שימוש בפסוק מספר בראשית פרק מ"ו, פס" כח המציג את העובדה כי גם בעת העתיקה התקיימה תופעה של שנאת ובוז לזר, כדוגמת יחסם של המצרים עובדי האדמה אל רועי הצאן - &quot;תועבת מצרים- כל רועה צאן&quot;.. בראשית פרק מ"ו, פס כ"ח.</p>
            <blockquote>שימוש בפסוק מספר בראשית פרק מ"ו, פס" כח המציג את העובדה כי גם בעת העתיקה התקיימה תופעה של שנאת ובוז לזר, כדוגמת יחסם של המצרים עובדי האדמה אל רועי הצאן - &quot;תועבת מצרים- כל רועה צאן&quot;.. בראשית פרק מ"ו, פס כ"ח.</blockquote>
            <figure
              style="max-width:1300pxpx"
              id="w-node-6698533a09ef-b6c51437"
              class="w-richtext-align-fullwidth w-richtext-figure-type-image"
            >
              <div>
                <img
                  src="images/109512946-student-doing-her-homework-writing-on-note-in-library.jpg"
                  alt
                />
              </div>
              <figcaption>כיתוב</figcaption>
            </figure>
            <p>‍</p>
            <h2>נקודות למחשבה</h2>
            <p>לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה דיאם. וסטיבולום אט דולור. לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה דיאם. לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה דיאם. וסטיבולום אט דולור. לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה דיאם.</p>
            <p>‍</p>
            <h2>שאלות חזרה</h2>
            <p>א. לענות על השאלות המופיעות בדף העבודה בדרך של ״נכון/ לא נכון״</p>
            <ol>
              <li>יהודה נשלח להכין את הקרקע לבוא אחיו</li>
              <li>אנשי מצרים היו רועי צאן</li>
              <li>בני ישראל יושבים במצרים</li>
              <li>יוסף היה במצרים לפני אחיו</li>
              <li>אחי יוסף יורדים למצרים</li>
              <li>אחי יוסף באים מארם נהרים</li>
              <li>יוסף מודיע ליהודה על בוא אחיו</li>
              <li>יוסף מעדיף שאחיו ישבו בארץ גושן</li>
              <li>יוסף אומר לאחיו שלא יספרו כי הם רועי צאן</li>
            </ol>
          </div>
        </div>
      </div>
      <div class="_792">
        <div class="share-me w-clearfix">
          <p class="paragraph-4">שיתוף</p>
          <div class="sharebox" style="margin-top:18px;">
            <a
              class="socialButton"
              title="שיתוף בפייסבוק"
              :href="'https://www.facebook.com/sharer/sharer.php?u=https://tanach5.org'+$route.fullPath"
            >
              <img src="../assets/images/social/fa_dark.svg" />
            </a>
            <a
              class="socialButton"
              title="שיתוף בטוויטר"
              :href="'https://twitter.com/home?status=https://tanach5.org'+$route.fullPath+' האתר ליחידות המוגברות בתנך'"
            >
              <img src="../assets/images/social/tw_dark.svg" />
            </a>
            <a
              class="socialButton"
              title="שליחה במייל"
              :href="'mailto:info@example.com?&subject=האתר ליחידות המוגברות בתנך&body=https://tanach5.org'+$route.fullPath"
            >
              <img src="../assets/images/social/mail_dark.svg" />
            </a>
            <a
              class="socialButton"
              :href="'whatsapp://send?text=האתר ליחידות המוגברות בתנך https://tanach5.org'+$route.fullPath"
              data-action="share/whatsapp/share"
            >
              <img src="../assets/images/social/wa_dark.svg" />
            </a>
          </div>
        </div>
        <div v-if="$parent.user" class="commen">
          <h2 class="h3">תגובות</h2>
          <div class="yellow-line"></div>
          <div v-if="comments">טרם נוספו תגובות - היה ראשון להגיב</div>
          <div v-for="comment in comments" :key="comment._id" class="lesson-box">
            <h4 class="lesson-head">{{comment.subject}}</h4>
            <p>{{comment.comment}}</p>
            <span style="font-size:17px; color:darkgrey; float:left;" v-if="comment.user">
              <strong>{{comment.user.name}}</strong>
              &nbsp;&nbsp;{{comment.user.email}}
            </span>
          </div>

          <h2 class="space-before head-30">הוספת תגובה חדשה</h2>

          <div class="div-block-4">
            <div class="user-info w-clearfix">
              <div class="profile-pic" :style="'background-image:url('+$parent.user.profileImg+')'"></div>
              <div class="name-box">
                <p class="name">{{$parent.user.name}}</p>
                <p class="name smaller">{{$parent.user.email}}</p>
              </div>
            </div>
            <div class="form-block-3 w-form">
              <form @submit="sendComment($event)" name="comment" class="form-new w-clearfix">
                <input
                  type="text"
                  class="field space-after w-node-e7f10dfb8e1e-aed1bd04 w-input"
                  maxlength="256"
                  placeholder="כותרת התגובה"
                  name="subject"
                />
                <textarea
                  id="node-4"
                  maxlength="5000"
                  placeholder="תוכן התגובה"
                  name="comment"
                  class="field space-after w-node-499187767a70-aed1bd04 w-input"
                  required
                ></textarea>
                <input
                  type="submit"
                  value="הוספת תגובה"
                  data-wait="נא להמתין"
                  class="yellow-btn left w-button"
                />
              </form>
              <div class="w-form-done">
                <div>נהדר, תגובתך נרשמה</div>
              </div>
              <div class="w-form-fail">
                <div>אופס, חלה תקלה נסו שנית</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="_792">
        <h2 class="h3">השיעורים הבאים</h2>
        <div class="lesson-box">
          <h4 class="lesson-head"></h4>
          <p></p>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";

export default {
  data() {
    return {
      currPage: "",
      article: {},
      comments: [],
      halufaname: "",
      teacherInfo: {
        topic: "",
        purpose: "",
        stratey: "",
        test: "",
        files: []
      },
      units: [],
      search: "",
      activeUnit: "",
      halufot: [],
      user: "",
      editing: false,
      mine: false
    };
  },
  methods: {
    deleteArticle() {
      if (confirm("בטוח למחוק?")) {
        window.db
          .doc(
            "/collections/jhW3eoxQQnZJNqBCzm7S/items/" + this.$route.params.id
          )
          .delete()
          .then(() => {
            this.$router.push("/alternative/" + this.article.halufa);
          });
      }
    },
    sendComment(e) {
      e.preventDefault();
      var obj = {};
      e.target.forEach(item => {
        if ($(item).attr("type") != "submit") {
          obj[$(item).attr("name")] = $(item).val();
        }
      });
      obj.user = window.db.doc(
        "collections/nZSsggipwqsg74x8nJBu/items/" +
          firebase.auth().currentUser.uid +
          "/"
      );
      window.db.collection(
        "/collections/jhW3eoxQQnZJNqBCzm7S/items/" +
          this.article._id +
          "/comments"
      )
        .add(obj)
        .then(res => {
          obj._id = res.id;
          obj.user = this.$parent.user;
          this.comments.push(obj);
        });
    },
    link(link) {
      window.location = link;
    },
    searchFunc(obj, child, term) {
      var include = {};
      for (i in obj){
          if (obj[i][child].match(new RegExp(term, "gi"))) {
          include[i] = obj[i];
        }
      }
      return include;
    },
    isMine() {
      this.$parent.user.halufot;
    },
    openTeacher() {
      if ($(".side-tech-box").hasClass("hidden")) {
        $(".side-tech-box").removeClass("hidden");
      } else {
        $(".side-tech-box").addClass("hidden");
      }
    },
    edit() {
      if (this.editing) {
        this.finishEditing();
      } else {
        this.startEditing();
      }
    },
    finishEditing() {
      this.editing = false;
      this.article.teacherInfo = this.teacherInfo;
      db.doc(
        "/collections/jhW3eoxQQnZJNqBCzm7S/items/" + this.$route.params.id
      ).update(this.article);
    },
    uploadImage(e) {
      var file = e.target.files[0];
      var storageRef = firebase
        .storage()
        .ref(`${this.article.name}/${file.name}`);
      var uploader = storageRef.put(file);
      uploader.on(
        "state_changed",
        () => {},
        err => {
          alert("error", err);
        },
        () => {
          uploader.snapshot.ref.getDownloadURL().then(url => {
            this.article.backgroundImg.url = url;
          });
        }
      );
    },
    startEditing() {
      var rtClick = "";
      this.editing = true;
      $.getScript(
        "https://cdnjs.cloudflare.com/ajax/libs/tinymce/5.0.3/tinymce.min.js",
        e => {
          tinymce.init({
            selector: "#content",
            menubar: false,
            statusbar: false,
            toolbar: false,
            plugins: [
              "lists",
              "autoresize",
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "media",
              "table",
              "paste",
              "imagetools",
              "hr"
            ],
            content_css:
              "https://sfo2.digitaloceanspaces.com/bagel/yechidot/yechidotRtf.css",
            height: "1480",
            paste_data_images: true,
            browser_spellcheck: true,
            image_caption: true,

            file_picker_callback(callback, value, meta) {
              if (meta.filetype == "image") {
                const input = document.createElement("input");
                input.setAttribute("type", "file");
                input.click();
                input.onchange = () => {
                  var file = input.files[0];
                  var storageRef = firebase
                    .storage()
                    .ref(`${vm.set.siteName}/rtf/${file.name}`);
                  var uploader = storageRef.put(file);
                  uploader.on(
                    "state_changed",
                    () => {},
                    err => {
                      alert("error", err);
                    },
                    () => {
                      uploader.snapshot.ref.getDownloadURL().then(url => {
                        callback(url);
                      });
                    }
                  );
                };
              }
            },
            file_picker_callback(callback, value, meta) {
              if (meta.filetype == "image") {
                const input = document.createElement("input");
                input.setAttribute("type", "file");
                input.click();
                input.onchange = () => {
                  var file = input.files[0];
                  var storageRef = firebase
                    .storage()
                    .ref(`${vm.article.name}/${file.name}`);
                  var uploader = storageRef.put(file);
                  uploader.on(
                    "state_changed",
                    () => {},
                    err => {
                      alert("error", err);
                    },
                    () => {
                      uploader.snapshot.ref.getDownloadURL().then(url => {
                        callback(url);
                      });
                    }
                  );
                };
              }
            },
            setup(editor) {
              editor.ui.registry.addButton("imgbtn", {
                text: "תמונה",
                onAction: function() {
                  console.log("context menu clicked");
                }
              });
              editor.ui.registry.addButton("hebQuote", {
                text: "",
                onAction: () => {
                  var node = editor.selection.getStart();
                  editor.selection.select(node);
                  editor.formatter.remove("enQuote");
                  editor.formatter.remove("regQuote");
                  editor.formatter.apply("hebQuote");
                }
              });
              editor.on("change", () => {
                tinymce.triggerSave();
                vm.article.content = editor.getContent();
              });
              editor.on("ContextMenu", () => {
                console.log("start");
                rtClick = true;
                setTimeout(() => {
                  rtClick = false;
                }, 200);
              });
              editor.ui.registry.addContextToolbar("imagealignment", {
                predicate(node) {
                  return node.nodeName.toLowerCase() === "img";
                },
                items: "alignleft aligncenter alignright",
                position: "node",
                scope: "node"
              });
              editor.ui.registry.addContextToolbar("textselection", {
                predicate(node) {
                  return !editor.selection.isCollapsed() && !rtClick;
                },
                items:
                  "bold italic underline forecolor h2 | blockquote link image media",
                position: "selection",
                scope: "node"
              });
            },
            contextmenu_never_use_native: true,
            contextmenu: "image cut paset | link imgbtn image media"
          });
        }
      );
    }
  },
  mounted() {
    window.vm = this;
    db.doc("/collections/jhW3eoxQQnZJNqBCzm7S/items/" + this.$route.params.id)
      .get()
      .then(doc => {
        this.article = doc.data();
        if (this.article.teacherInfo) {
          this.teacherInfo = this.article.teacherInfo;
        }
        db.collection(
          "/collections/jhW3eoxQQnZJNqBCzm7S/items/" +
            this.$route.params.id +
            "/comments"
        )
          .get()
          .then(comments => {
            comments.forEach(comment => {
              var data = comment.data();
              data._id = comment.id;
              db.doc(data.user.path)
                .get()
                .then(user => {
                  this.comments.find(e => {
                    return e._id == data._id;
                  }).user = user.data();
                });
              this.comments.push(data);
            });
          });
        var title = $(document).prop("title");
        $(document).prop("title", title + " " + doc.data().name);
        db.doc("/collections/oVwbkKRU39ykpil2lw62/items/" + this.article.halufa)
          .get()
          .then(doc => {
            var data = doc.data();
            if (data) {
              this.halufaname = data.name;
              if (this.$parent.user.halufot.includes(doc.id)) {
                this.mine = true;

                if (window.location.search == "?edit") {
                  this.startEditing();
                }
              }
            }
          });
      });
  },
  computed: {
    busFilter() {
      if (!this.search) {
        return this.businesses;
      } else {
        //var term = new RegExp(this.selectedUI.search, 'gi')
        //return this.categories.filter((e)=>{e.name.match(term)})
        return this.searchFunc(this.businesses, "businessName", this.search);
      }
    }
  },
  watch: {
    editing() {
      if (!this.editing) {
        $(".tox.tox-tinymce").remove();
      } else {
        setTimeout(() => {
          autosize($("textarea"));
        }, 1);
      }
    }
  }
};
</script>
<style>
div.tox-tinymce {
  clear: both !important;
}
</style>
<style scoped>
.paragraph-rtf.w-richtext {
  clear: both !important;
}
.div-block-4 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.name-box {
  display: inline-block;
  float: right;
}
.name {
  margin-bottom: 0px;
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
}
.name.smaller {
  color: #7a7a7a;
  font-size: 12px;
  line-height: 15px;
}
.form-block-3 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.user-info {
  margin-top: 9px;
  margin-bottom: 19px;
  margin-left: 20px;
}
.field.space-after.w-input {
  width: 100%;
  border: 1px solid #e4e4e4;
  background: white;
  margin-bottom: 10px;
}
.yellow-btn.left {
  margin-top: 10px;
  float: left;
}
.info-name {
  display: inline-block;
  padding: 20px;
}
.profile-image {
  display: inline-block;
  height: 60px;
  width: 60px;
  border-radius: 100%;
  margin-bottom: -5px;
  background: lightgrey;
}
.btn.w-button {
  display: block;
  max-width: 140px;
  text-align: center;
  margin-bottom: 10px;
}
textarea.author {
  width: 100%;
  height: 34px;
}
.mainImageupld {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.editImage {
  position: absolute;
  bottom: 24px;
  right: 25px;
  background: rgba(255, 255, 255, 0.9);
  padding: 10px;
  border-radius: 5px;
}
.hero-grad {
  position: relative;
}
.smallLabel {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
}
div.authorlink {
  width: 80%;
  margin-right: 10px;
}
input[type="text"] {
  width: 100%;
  border: none;
  background: none;
  margin-bottom: 10px;
  border-bottom: 1px dashed darkgrey;
}
.side-txt {
  white-space: pre-line;
}
textarea.side-txt {
  resize: none;
  box-sizing: border-box;
  border: 1px dashed darkgray;
  width: 100%;
  background: none;
}
.main-head.on-hero {
  left: calc(50% - 256px);
  right: calc(50% - 256px);
  height: 70px;
}
.editer {
  background: none;
  border: none;
  border-bottom: 1px dashed yellow;
}
.floatleft {
  margin-bottom: 20px;
}
.tox-tinymce {
  border: 1px darkgray dashed !important;
}
.tox .tox-edit-area {
  border: none !important;
}
.tox .tox-edit-area__iframe {
  background-color: transparent !important;
}
._650 {
  display: inline-block;
  width: auto;
  float: none;
}
</style>
